export default {"src":"/_next/static/media/CZR.4752abaa.svg","height":18,"width":18};